import React from 'react'
import Pane from 'components/Common/Pane'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import PartnerCarousel from 'components/Common/PartnerBrands/PartnerCarousel'

interface Props {
  className?: string
}

function PartnerBrands({
  className,
}: Props) {
  return (
    <Pane className={className}>
      <LayoutContainer>
        <Group direction="vertical" gap={16}>
          <Group direction="vertical" gap={8}>
            <Heading variant="heading2">
              We partner with the world’s best brands
            </Heading>
            <BodyText variant="large">
              Thousands of the best hotels, tours and cruises at your fingertips
            </BodyText>
          </Group>
          <PartnerCarousel />
        </Group>
      </LayoutContainer>
    </Pane>
  )
}

export default PartnerBrands
